import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
import Layout from "@/views/Layout.vue";
import Product from "@/views/Product.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Layout,
    redirect: { name: "home" },
    children: [
      {
        path: "/home",
        name: "home",
        component: Home,
        meta: {
          title: "首頁 | 澄安科技企業社 Cheng An Technology Enterpries",
        },
      },
      {
        path: "/product",
        name: "product",
        component: Product,
        meta: {
          title: "產品介紹 | 澄安科技企業社 Cheng An Technology Enterpries",
        },
      },
    ],
  },
  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  //跳轉畫面後，滾動到x:0的位置
  scrollBehavior(to, from, savePosition) {
    if (savePosition) {
      return savePosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
